import OptionIcon from "pages/ManagementPage/OptionIcon/OptionIcon";

export default OptionIcon;
